
// biome-ignore assist/source/organizeImports: off
import { motion } from 'framer-motion';

import BackButton from '../../components/BackButton/BackButton';
import Card from '../../components/VerticalCard';

import { titleSection } from '../../animations/PageAnimations';
import { useAppSelector } from '../../hooks';

const OpenAnAccount = () => {
  const ID_SECTION = 'open-an-account';
  const section = useAppSelector(state => state.webSettings.sections.find(sec => sec.id === ID_SECTION));

  return (
    <section className="mx-auto px-12 pt-8">
      <motion.div
        initial="initial"
        animate="animate"
        exit="exit"
        key="title-open-an-account"
        variants={titleSection}
      >
        <BackButton />
        <h1 className="mt-4 xl:mt-6 font-bold"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: off
          dangerouslySetInnerHTML={{__html:section?.title || ''}}/>
      </motion.div>

      <motion.div className="mt-6 xl:mt-8 flex flex-row"
        key="content-open-an-account"
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <div className="cards-vertical grid grid-cols-3 gap-4 xl:gap-8 w-full">

          { section?.cards?.map((cardData, index) => {
            const card = cardData;
            return (
              <Card
                {...card}
                index={index + 1}
                key={card.id}
              />
            );
          })}

        </div>

      </motion.div>
    </section>
  );
};

export default OpenAnAccount;
